import { render, staticRenderFns } from "./ConfirmLevelUpDialog.vue?vue&type=template&id=f080cd90&scoped=true&"
import script from "./ConfirmLevelUpDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmLevelUpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmLevelUpDialog.vue?vue&type=style&index=0&id=f080cd90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f080cd90",
  null
  
)

export default component.exports